type SelectOption = {label: string; id: string};

export function generateOptions<T extends Record<string, string>>(
  typeObj: T,
  localePath: string,
  td: (key: string) => string
): SelectOption[] {
  return Object.keys(typeObj).map((key) => ({
    label: td(`${localePath}.${typeObj[key]}`),
    id: typeObj[key],
  }));
}

export const MONTH_OPTIONS: SelectOption[] = Array.from({length: 12}, (_, i) => ({
  label: `${i + 1}`,
  id: `${i + 1}`,
}));

export const buildYearOptions = (count = 50): SelectOption[] =>
  Array.from({length: count}, (_, i) => {
    const year = new Date().getFullYear() - i;
    return {label: year.toString(), id: year.toString()};
  });
